var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96065 8.0689C6.54585 8.4837 6.49175 9.13755 6.8327 9.6149L8.36315 11.7576L7.6 13.6L5.0027 14.0329C4.42409 14.1293 4 14.6299 4 15.2165V16.7834C4 17.37 4.42409 17.8707 5.0027 17.9671L7.6 18.4L8.36325 20.2426L6.8328 22.3853C6.49185 22.8626 6.54595 23.5165 6.96075 23.9313L8.0687 25.0392C8.4835 25.4541 9.13735 25.5082 9.6147 25.1672L11.7573 23.6367L13.6 24.4L14.0329 26.9973C14.1293 27.5759 14.6299 28 15.2165 28H16.7834C17.37 28 17.8707 27.5759 17.9671 26.9973L18.4 24.4L20.2428 23.6367L22.3853 25.1671C22.8627 25.5081 23.5166 25.454 23.9314 25.0392L25.0394 23.9312C25.4542 23.5164 25.5082 22.8626 25.1673 22.3852L23.6369 20.2425L24.4 18.4L26.9973 17.9671C27.5759 17.8707 28 17.37 28 16.7834V15.2165C28 14.6299 27.5759 14.1293 26.9973 14.0329L24.4 13.6L23.6367 11.7573L25.1672 9.6147C25.5082 9.13735 25.4541 8.4835 25.0392 8.0687L23.9313 6.96075C23.5165 6.54595 22.8626 6.49185 22.3853 6.8328L20.2426 8.36325L18.4 7.6L17.9671 5.0027C17.8707 4.42409 17.37 4 16.7834 4H15.2165C14.6299 4 14.1293 4.42409 14.0329 5.0027L13.6 7.6L11.7573 8.36345L9.61465 6.83295C9.1373 6.492 8.4834 6.54615 8.0686 6.96095L6.96065 8.0689Z",
    fill: "url(#paint0_linear_2149_31237)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16C23 19.866 19.866 23 16 23C12.134 23 9 19.866 9 16C9 12.134 12.134 9 16 9C19.866 9 23 12.134 23 16Z",
    fill: "url(#paint1_linear_2149_31237)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16C19 17.6568 17.6568 19 16 19C14.3432 19 13 17.6568 13 16C13 14.3432 14.3432 13 16 13C17.6568 13 19 14.3432 19 16Z",
    fill: "#080808"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2149_31237",
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31B5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2149_31237",
    x1: 16,
    y1: 9,
    x2: 16,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.1f459b8d415181cdd26cd2478d870ebb.svg";
export { ForwardRef as ReactComponent };